import React from "react";
import { GetResourceSearchResultsItem } from "@/api/getResourceSearchResults/types";
import { ResourceCard } from "@/modules/hub/features/ResourceLibrary/components/ResourceCard/ResourceCard";

interface PodcastCardProps {
  resource: GetResourceSearchResultsItem;
  showFeaturedBadge?: boolean;
  variant?: "default" | "featured";
  onToggleFavorite?: (uuid: string, isFavorited: boolean) => void;
}

export function PodcastCard({
  resource,
  showFeaturedBadge = false,
  variant = "default",
  onToggleFavorite,
}: PodcastCardProps) {
  return (
    <ResourceCard
      onToggleFavorite={onToggleFavorite}
      resource={resource}
      showFeaturedBadge={showFeaturedBadge}
      variant={variant}
    />
  );
}